import React from 'react';
import './AddPage.scss';
import { Button, Card, Checkbox, Icon, Input, Textarea, Typography } from '@design-system/index';
import { Formik } from 'formik';
import { MembersListLine } from '@icons';
import { useAddPageVM } from './useAddPageVM';
import { FileUpload } from '@components/FileUpload/FileUpload';
import { CdnFile } from '@services/core/cdn/file/file';
import { FlashInfoToCreate } from '@services/member/flash-info/flash-info.types';

export default function AddPage() {
    const { submitForm, isLoading, flashInfo, isEdit } = useAddPageVM();
    return (
        <div className="add-member-container">
            <Card
                isLoading={isLoading}
                headerType="full"
                showBack
                headerTitle={isEdit ? 'Modification information flash' : 'Création nouvelle information flash'}
                headerIcon={<Icon icon={<MembersListLine />} size={20} color="primary" />}
            >
                <>
                    <Formik
                        initialValues={
                            flashInfo || {
                                title: '',
                                content: '',
                                isActive: true,
                                image: undefined,
                                link: ''
                            }
                        }
                        enableReinitialize
                        onSubmit={async (values: FlashInfoToCreate) => {
                            await submitForm(values);
                        }}
                    >
                        {({ values, handleChange, handleSubmit, setFieldValue, isSubmitting }) => {
                            console.log(values);
                            return (
                                <form onSubmit={handleSubmit} className="form">
                                    <div className="form-section-container">
                                        <div className="form-section">
                                            <Typography intrinsic="h3">Informations générales</Typography>
                                            <div className="form-section-fields">
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <Checkbox
                                                            checked={values.isActive}
                                                            onChange={(checked) => {
                                                                setFieldValue('isActive', checked);
                                                            }}
                                                        >
                                                            <Typography intrinsic="p" color="secondary">
                                                                Activé
                                                            </Typography>
                                                        </Checkbox>
                                                    </div>
                                                </div>
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <Input
                                                            label="Titre"
                                                            name="title"
                                                            value={values.title}
                                                            required
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <Textarea
                                                            label="Contenu"
                                                            wysiwyg
                                                            required
                                                            name="content"
                                                            value={values.content ?? ''}
                                                            onChange={(value) => {
                                                                setFieldValue('content', value);
                                                            }}
                                                            height={220}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <Input
                                                            type="text"
                                                            name="link"
                                                            label="Lien"
                                                            value={values.link}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <FileUpload
                                                            width="400px"
                                                            height="400px"
                                                            caption="Image"
                                                            subtitle={
                                                                <>
                                                                    Image au format portait rectangulaire.
                                                                    <br />
                                                                    Formats acceptés : PNG, JPEG.
                                                                    <br />
                                                                    Ratio conseillé : 720x1280 pixels.
                                                                </>
                                                            }
                                                            isMultiple={false}
                                                            isImage={true}
                                                            files={values.image}
                                                            onSuccess={(files: CdnFile[]) => {
                                                                setFieldValue('imageId', files[0]?.id);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="action-buttons">
                                        <Button type="submit" disabled={isSubmitting} variant="primary">
                                            {isEdit ? 'Valider la modification' : 'Valider la création'}
                                        </Button>
                                    </div>
                                </form>
                            );
                        }}
                    </Formik>
                </>
            </Card>
        </div>
    );
}
